import { useEffect, useState } from "react";
import { photosAPI } from "../services/api";
import { useProjectContext } from "./useProjectContext";

export const usePhotos = () => {
  const { activeProject } = useProjectContext();
  const projectId = activeProject?.id;

  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  const load = async () => {
    if (!projectId) return;
    setLoading(true);
    setError(null);
    try {
      const res = await photosAPI.listByProject(projectId);
      setPhotos(res.data || []);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  };

  const upload = async (formData) => {
    if (!projectId) throw new Error("No active project selected");
    setUploading(true);
    setError(null);
    try {
      const res = await photosAPI.upload(projectId, formData);
      setPhotos((prev) => [res.data, ...prev]);
      return res.data;
    } catch (e) {
      setError(e);
      throw e;
    } finally {
      setUploading(false);
    }
  };

  const remove = async (photoId) => {
    if (!projectId) throw new Error("No active project selected");
    await photosAPI.delete(projectId, photoId);
    setPhotos((prev) => prev.filter((p) => p.id !== photoId));
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  return { photos, loading, uploading, error, reload: load, upload, remove };
};
